import { handleGTMPreviewAccommodationOpen } from "@/helpers/gtm/handleGTMPreviewAccommodationClick.ts";
import { RateGroup } from "@/helpers/types/types.ts";
import { useEffect } from "react";

export const useGTMAccommodationPreviewOpen = (RG: RateGroup) => {
  useEffect(() => {
    if (!RG) return;

    handleGTMPreviewAccommodationOpen(RG);
  }, [RG]);
};
